import React, { Component } from 'react';
import styles from './style.scss';
import IconComponent from '../../../portal/iconComponent';
import { inject } from 'mobx-react';

@inject('translationsStore')
export default class ClosedServiceProvider extends Component {

    render() {

        return (
            <div className={styles.closedServiceProvider}>
                <div className={styles.permissionsGroupHeader}>
                    <div className={styles.iconWrapper}>
                        <IconComponent iconClassName='plus-large-icon' onClick={this.props.onOpenServiceProvider} />
                    </div>
                    <div>
                    <div className={styles.permissionsGroupHeaderTitle}>
                        {this.props.serviceProviderName}
                    </div>
                    <div className={styles.permissionsGroupHeaderSubTitle}>
                        {this.props.permissionsCount} {this.props.translationsStore.translate('PERMISSIONS_SELECTED')}
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/roles/editRole/permissionsItem/closedServiceProvider.jsx